import { normalize, schema } from 'normalizr';
import { ParticipantViewModel } from 'stageclip-common';

import { ById } from '../../store/normalizedState';

import * as EntityNormalizers from './entityNormalizers';

const { Entity } = schema;

export interface NormalizedParticipants {
  participants: ById<ParticipantViewModel>;
}

export const participantsSchema = new Entity('participants');

export function normalizeParticipant(
  data: ParticipantViewModel,
): EntityNormalizers.NormalizedSingleEntity<NormalizedParticipants> {
  return normalize(data, participantsSchema);
}

export function normalizeParticipantsArray(
  data: ParticipantViewModel[],
): EntityNormalizers.NormalizedEntityArray<NormalizedParticipants> {
  return normalize(data, new schema.Array(participantsSchema));
}

export interface NormalizedParticipantsSampleView {
  status: string;
}

export function normalizeParticipantSample(
  data: NormalizedParticipantsSampleView,
): EntityNormalizers.NormalizedSingleEntity<NormalizedParticipantsSampleView> {
  return normalize(data, participantsSchema);
}
